module.exports = __webpack_public_path__ + "img/icon_average.65ec85b5.png";